import { CurrencyPipe } from '@angular/common';
import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { BasicList } from '@app/models';
import { AppInfoService, CommonService, ProjectService } from '@app/services';

interface ProjectTypeSummary {
  id: number;
  count: number;
  name: string;
  averageCost: number;
}

@Component({
  selector: 'qb-projects-summary',
  templateUrl: './projects-summary.component.html',
  styleUrls: ['./projects-summary.component.scss'],
  imports: [CurrencyPipe],
})
export class ProjectsSummaryComponent implements OnInit {
  private destroyRef = inject(DestroyRef);

  projectTypeSummeries: ProjectTypeSummary[] = [];

  private projectTypes: BasicList[] = [];

  constructor(
    private app: AppInfoService,
    private commonServices: CommonService,
    private projectServices: ProjectService
  ) {}

  ngOnInit(): void {
    this.commonServices
      .getProjectTypes()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(res => {
        this.projectTypes = res;

        this.projectTypes.forEach(projectType => {
          this.projectTypeSummeries.push({ id: projectType.id, name: projectType.name, count: 0, averageCost: 0 });
        });

        this.initProjectSummary();
      });
  }

  initProjectSummary(): void {
    this.projectServices
      .getProjects(this.app.id)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(projects => {
        // get a count for each type
        this.projectTypes.forEach(projectType => {
          let count = 0;
          let total = 0;

          projects.forEach(project => {
            if (project.projectTypeId === projectType.id && project.isValid) {
              count++;
              total += project.projectValue;
            }
          });

          const projectTypeIndex = this.projectTypeSummeries.findIndex(item => item.id === projectType.id);
          const projectTypeSummary = this.projectTypeSummeries[projectTypeIndex];

          projectTypeSummary.count = count;
          projectTypeSummary.averageCost = total / count;
        });
      });
  }
}
